<template>
  <span>
    <v-btn text small color="primary" href="https://app.docpool.io/signup" target="_blank">
      Get your own page at Docpool
    </v-btn>
  </span>
</template>

<script>
export default {
  name: 'poweredByLink'
}
</script>

<style>

</style>
